import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/recruiting-statuses/new/loading';

export const Route = createFileRoute('/_private/settings/recruiting-job-categories/new')({
  component: Loading,
});
